import axios from '../../../axios'

// 获取列表
export const list = (data) => {
  return axios({
    url: '/basic/project/list',
    method: 'post',
    data
  })
}

// 保存信息
export const save = (data) => {
  return axios({
    url: '/basic/project/save',
    method: 'post',
    data
  })
}
// 查看
export const view = (data) => {
  return axios({
    url: '/basic/project/view',
    method: 'post',
    data
  })
}
// 编辑
export const edit = (data) => {
  return axios({
    url: '/basic/project/edit',
    method: 'post',
    data
  })
}
// 删除
export const doDelete = (data) => {
  return axios({
    url: '/basic/project/delete',
    method: 'post',
    data
  })
}
// 由路段获取分段信息
export const getSection = (data) => {
  return axios({
    url: '/basic/project/getSection',
    method: 'post',
    data
  })
}
// 获取路段基本信息
export const getInfo = (data) => {
  return axios({
    url: '/basic/project/getInfo',
    method: 'post',
    data
  })
}

// 查询
export const getSelectData = (data) => {
  return axios({
    url: '/basic/project/getSelectData',
    method: 'post',
    data
  })
}

// 获取所有养护段为
export const getMaintenanceUnitList = (data) => {
  return axios({
    url: '/basic/project/getMaintenanceUnitList',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/biz/basic/project.js